"use client"

import { useCollectionStatitstic } from "@/app/collections/statistic/use-floor"
import { PriceWrapper } from "@/app/price"
import type { NftMiniature } from "@anaconda/core/nft/types"
import { Trans } from "@lingui/macro"
import { Skeleton } from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"

interface Props {
  nft: NftMiniature
}

export const PriceStatistic = reatomComponent<Props>((props) => {
  const { data: statistic, isLoading } = useCollectionStatitstic(
    props.nft.collection.id,
  )

  if (isLoading) {
    return <Skeleton className="h-5 w-40" />
  }

  return (
    <>
      {statistic?.topOffer && (
        <span>
          <Trans>Top offer:</Trans>{" "}
          <PriceWrapper {...statistic.topOffer} className="text-base" />
        </span>
      )}
      {statistic?.floor && (
        <span>
          <Trans>Floor:</Trans>{" "}
          <PriceWrapper {...statistic.floor} className="text-base" />
        </span>
      )}
    </>
  )
}, "PriceStatistic")
